import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import { checkIsProductionMode } from './utils/environment';

import { Root } from './root.component';
import { Dataset, TLanguageCode, THidePhone } from './root.types';

if (checkIsProductionMode() && !!process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
  });
}

((): void => {
  const element = document.getElementById('demo-request-form');

  if (!element) {
    console.error('Can not find html element with id="demo-request-form"'); // eslint-disable-line no-console
    return;
  }

  const source = element.dataset[Dataset.SOURCE];
  const languageCode = element.dataset[Dataset.LANGUAGE] as TLanguageCode || 'EN';
  const hidePhoneData = element.dataset[Dataset.HIDE_PHONE] as THidePhone;
  const hidePhone = hidePhoneData === 'true' || hidePhoneData === true;

  if (!source) {
    console.error('Can not find data attributes in html element with id="demo-request-form"'); // eslint-disable-line no-console
    return;
  }

  ReactDOM.render(
    <React.StrictMode>
      <Root
        source={source}
        languageCode={languageCode}
        hidePhone={hidePhone}
      />
    </React.StrictMode>,
    element,
  );
})();
